export const SET_IS_LOGGED = 'SET_IS_LOGGED';
export const SET_IS_ADMIN = 'SET_IS_ADMIN';
export const SET_IS_ROUTE_AUTHORIZED = 'SET_IS_ROUTE_AUTHORIZED';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
